<template>
    <div class="rule-box">
        <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft"/>
        <div class="content">
            <p>注：大小不超过2M的JPG或PNG图片</p>
            <div class="boxCnrd">
                <h4>加盖公章的营业执照复印件 <span>*</span></h4>
                <template v-if="!licenceURL">
                    <van-uploader
                            v-model="fileList"
                            :after-read="afterLicenceFileId"
                            @delete="delFile('licenceFileId')"
                            :max-count="1"
                    >
                    </van-uploader>
                </template>
                <template v-else>
                    <van-uploader
                            v-model="fileList"
                            :after-read="afterLicenceFileId"
                            @delete="delFile('licenceFileId')"
                            :max-count="1"
                    >
                        <img :src="licenceURL">
                    </van-uploader>
                    <!--<div class="demo-image">
                         <div class="iconBox" @click="licenceURL=''">
                            <van-icon name="cross" />
                         </div>
                         <van-image width="100" height="100" :src="licenceURL"   />
                    </div>-->
                </template>
            </div>
            <div  class="boxCnrd">
                <h4>单位logo<span></span></h4>
                <template v-if="!portraitURL">
                    <van-uploader
                            v-model="fileList2"
                            :after-read="afterPortraitFile"
                            @delete="delFile('portraitId')"
                            :max-count="1"
                    />
                </template>
                <template v-else>
                    <van-uploader
                            v-model="fileList"
                            :after-read="afterPortraitFile"
                            @delete="delFile('portraitId')"
                            :max-count="1"
                    >
                        <img :src="portraitURL">
                    </van-uploader>
                    <!--<div class="demo-image">
                        <div class="iconBox" @click="portraitURL=''">
                            <van-icon name="cross" />
                        </div>
                        <van-image width="100" height="100" :src="portraitURL" />
                    </div>-->

                </template>
            </div>
            <div class="buton">
                <van-button type="primary" size="large" @click="save">保存</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import vHead from "@/components/Subhead.vue";
    import { Uploader,Toast,Button,NavBar,Image ,Icon } from "vant";
    import { uploadFile, delFile } from "@/api/upload";
    import { getPZUrl,getUser} from "@/api/dictionary";
    import { mapState} from "vuex";
    import { registerMemberEdit } from "@/api/login";

    export default {
        data() {
            return {
                fileList: [],
                fileList2: [],
                licenceURL: "",
                portraitURL: "",
                params:{
                    licenceFileId: null,
                    licenceFileName: null,
                    portraitId: null,
                    portraitName: null,
                },
                title:"附件上传"
            };
        },
        components: {
            vHead,
            [Uploader.name]: Uploader,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [NavBar.name]:NavBar,
            [Image.name]:Image ,
            [Icon.name]:Icon ,
        },
        methods: {
            afterLicenceFileId(fileObj) {
                this.params.licenceFileName =fileObj.file.name;
                let params = new FormData();
                params.append("file", fileObj.file);
                uploadFile(params).then(res => {
                    if (res.success) {
                        this.params.licenceFileId = res.result.id;
                        Toast("上传成功");
                    } else {
                        Toast("删除失败");
                    }
                }).catch(() => {
                    //失败
                });
            },
            afterPortraitFile(fileObj) {
                this.params.portraitName =fileObj.file.name;
                let params = new FormData();
                params.append("file", fileObj.file);
                uploadFile(params).then(res => {
                    if (res.success) {
                        this.params.portraitId = res.result.id;
                        Toast("上传成功");
                    } else {
                        Toast("删除失败");
                    }
                });
            },
            delFile(type) {
                let id = this.params[type];
                if (id) {
                    let params = {
                        id
                    };

                    delFile(params).then(res => {
                        if (res.success) {
                            Toast("删除成功");
                        } else {
                            Toast("删除失败");
                        }
                    });
                }
            },
            save(){
                if(this.params.licenceFileId || this.params.portraitId){
                    this.$router.push({name:"editMember",query:{source:1,licenceFileId:this.params.licenceFileId,licenceFileName:this.params.licenceFileName,portraitId:this.params.portraitId,portraitName:this.params.portraitName}})
                }else{
                    Toast("请上传图片");
                }
            },
            onClickLeft() {
                this.$router.push({name:"editMember",query:{source:1}})
            },
            getImg() {
                if(this.portraitId){
                    getPZUrl({ id: this.portraitId })
                        .then(res => {
                            if (res.success) {
                                if (res.result) {
                                    this.portraitURL=res.result ;
                                } else {
                                    this.fileList = [];
                                }
                            }
                        })
                }
                if(this.licenceFileId) {
                    getPZUrl({id: this.licenceFileId})
                        .then(res => {
                            if (res.success) {
                                if (res.result) {
                                    this.licenceURL=res.result;
                                } else {
                                    this.fileList = [];
                                }
                            }
                        })
                }
            }
        },
        computed:{
            ...mapState(["userInfo"]),
            sendActiveRouter() {
                return this.$route.query && this.$route.query.sendActiveRouter;
            },
            licenceFileId() {
                return this.$route.query && this.$route.query.licenceFileId;
            },
            portraitId() {
                return this.$route.query && this.$route.query.portraitId;
            }
        },
        mounted() {
            let _this = this;
            getUser().then(res=>{
                if(res.success){
                    _this.getImg();
                }
            })
        },
    };
</script>

<style lang="less" scoped>
    p {
        margin-bottom: 10px;
    }
    b {
        font-weight: bold;
        margin-right: 10px;
    }
    ul {
        li {
            margin-bottom: 5px;
            line-height: 1.5;
        }
    }
    // .boxCnrd{ display: inline-block; text-align: center; width: 50%;}
    .content{
        padding:20px;
        .van-button--large{
            height:45px; line-height:35px; margin-top: 15px;
        }
        p{ font-size: 14px; color: #d64a4a; margin:10px 0;}
        h4{
            font-size: 15px; margin: 20px 0;
            span{color: #d64a4a;  font-size: 13px;}
        }
    }
    /deep/.van-uploader__upload,/deep/.van-uploader__preview,/deep/.van-uploader__preview-image
    { background: #f7f8fa; width: 100px; height: 100px;}
    .buton{ width: 80%; margin: 0 auto; margin-top: 20px;}
    .demo-image{ position: relative;width: 15.7%; margin-right: 10px; margin-bottom: 15px;}
    .demo-image .iconBox{ position: absolute; width: 20px; height: 20px; right:0; top:0; background: #000; color: #fff; text-align: center; line-height: 20px}
    .rule-box img{ max-width: 100%;}
</style>

